<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <h1>Ad-hoc-Spiel starten</h1>
        <v-form>
          <v-text-field label="Team A Name" v-model="teamA" outlined></v-text-field>
          <v-text-field label="Team B Name" v-model="teamB" outlined></v-text-field>
          <v-btn block color="primary" @click="startGame">Spiel starten</v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      teamA: '',
      teamB: '',
    };
  },
  methods: {
    startGame() {
      if (this.isAuthenticated()) {
        console.log("Spiel gestartet", this.teamA, this.teamB);
      } else {
        this.showAuthModal();
      }
    },
    isAuthenticated() {
      // Hier sollte eine echte Authentifizierungslösung integriert werden
      return false; // Platzhalter: Benutzer ist nicht authentifiziert
    }
  },
};
</script>

<style scoped>
h1 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
}
</style>